<template>
  <div id="websop-public-container" class="container-fluid">
    <no-data-box v-if="!isWebShopEnabled || !hasActiveStripeAccount">
      <h5 class="text-center">
        {{ $t(LangConstants.feature_not_available_text) }}
      </h5>
    </no-data-box>

    <shop-preview :instanceId="instanceIdx" :webshop="webshop"
      v-if="isWebShopEnabled && hasActiveStripeAccount && webshop.length > 0" :isPreview="false"
      :defaultPrviewCourse="defaultPrviewCourseX"></shop-preview>
  </div>
</template>

<script>
/**
 * Webshop Public Page
 */
import ShopPreview from "../../../components/organisms/ShopPreview.vue";
import NoDataBox from "../../../components/atoms/NoDataBox.vue";
import Constants from "../../../constants/index";

export default {
  name: "web-shop-public",
  created() {

  },

  mounted() {
    this.instanceId = this.$route.params.instance_id;
    const session_id = this.$route.query.session_key ? this.$route.query.session_key : 0;

    this.isWebShopEnabled = true;
    this.hasActiveStripeAccount = true;

    const product_id = this.$route.params.product_id;
    this.defaultPrviewCourse = product_id;

    this.$store.dispatch("getAllSettings").then(() => {
      if (this.woocommerceIntegration == true) {

        this.$store.dispatch("readAllWebShop", { instance_id: this.instanceId }).then((result) => {
          /*
            this.webshop = result.data
              .filter((item) => item.webshop === true)
              .map((item) => {
                // Predefine properties for reactivity
                return {
                  ...item,
                  prices: [],
                  price: 0,
                  signedIn: false,
                  signInLink: "",
                };
              });
  
            // Now loop through and update reactively after WooCommerce API call
            this.webshop.forEach((item, index) => {
              if (item.external_id) {
                const singleProductAPI = this.generalSetting("woocommerce_integration_single_product_api")
                  .replace("SESSION_KEY", session_id)
                  .replace("PRODUCT_ID", item.external_id);
  
                this.$store.dispatch("getRaw", { url: singleProductAPI, config: "" }).then((filteredResult) => {
                  const signedIn = filteredResult.signed_in;
                  const signInLink = filteredResult.signin_link;
                  const data = filteredResult.data;
  
                  if (!data || data.availability === 0) return;
  
                  // Create updated course with WooCommerce data
                  const updatedItem = {
                    ...item,
                    price: data.default_price ? data.default_price / 100 : 0,
                    prices: data.prices.length > 1 ? data.prices : [],
                    signedIn,
                    signInLink,
                    courseInstance: {
                      ...item.courseInstance,
                      name: data.title,
                    },
                  };
  
                  // Replace reactively
                  this.$set(this.webshop, index, updatedItem);
                });
              }
            });
          */

          /*
 
             this.webshop = result.data.filter((item) => {
             if (item.external_id && item.webshop == true) {
 
               const singleProductAPI = this.generalSetting("woocommerce_integration_single_product_api")
                 .replace("SESSION_KEY", session_id)
                 .replace("PRODUCT_ID", item.external_id);
 
               this.$store.dispatch("getRaw", { url: singleProductAPI, config: "" }).then((filteredResult) => {
 
                 let signedIn = filteredResult.signed_in;
                 let signInLink = filteredResult.signin_link;
                 filteredResult = filteredResult.data;
 
                 if (!filteredResult) {
                   return false;
                 }
 
                 if (filteredResult.availability != undefined && filteredResult.availability == 0) {
                   return false;
                 }
 
                 item.price = filteredResult.default_price ? filteredResult.default_price / 100 : 0;
                 item.prices = filteredResult.prices.length > 1 ? filteredResult.prices : [];
                 item.courseInstance.name = filteredResult.title;
                 item.signedIn = signedIn;
                 item.signInLink = signInLink;
 
               });
             }else{
               item.prices =  [];
               item.signedIn = false;
               item.signInLink = "";
             }
 
             return item.webshop == true ? true : false;
           });
          */

          const filteredItems = result.data
            .filter((item) => item.webshop === true)
            .map((item) => ({
              ...item,
              prices: [],
              signedIn: false,
              signInLink: "",
            }));

          const updatePromises = filteredItems.map((item, index) => {
            if (!item.external_id) return Promise.resolve();

            // skip if item.id is not equal to  product_id on the route parameter¨


            if(this.$route.params.product_id !== '0'){
              if (this.$route.params.product_id && item.course_id !== parseInt(this.$route.params.product_id)) {
                return Promise.resolve();
              }
            }

            const singleProductAPI = this.generalSetting("woocommerce_integration_single_product_api")
              .replace("SESSION_KEY", session_id)
              .replace("PRODUCT_ID", item.external_id);

            return this.$store.dispatch("getRaw", { url: singleProductAPI, config: "" }).then((res) => {
              const data = res.data;
              if (!data || data.availability === 0) return;

              const updated = {
                ...item,
                prices: data.prices.length > 1 ? data.prices : [],
                price: data.default_price ? data.default_price / 100 : 0,
                signedIn: res.signed_in,
                signInLink: res.signin_link,
                courseInstance: {
                  ...item.courseInstance,
                  name: data.title,
                },
              };

              filteredItems[index] = updated;
            });
          });

          Promise.all(updatePromises).then(() => {
            this.webshop = filteredItems;
          });

        });

      } else {
        this.$store.dispatch("readAllWebShop", { instance_id: this.instanceId }).then((result) => {
          this.webshop = result.data.filter((item) => {
            return item.webshop == true ? true : false;
          });
        });
      }
    });
  },

  computed: {
    instanceIdx() {
      return this.instanceId;
    },
    defaultPrviewCourseX() {
      return this.defaultPrviewCourse ? this.defaultPrviewCourse : 0;
    },
    LangConstants() {
      return Constants;
    },

    woocommerceIntegration() {
      const settings = this.$store.getters.generalSettings;

      if (settings != null && settings.instanceSettings.woocommerce_integration == 1) {
        return true;
      }

      return false;
    },
  },
  data() {
    return {
      customer: [],
      webshop: [],
      splittedCourses: [],
      isWebShopEnabled: false,
      hasActiveStripeAccount: false,
      defaultPrviewCourse: 0,
      instanceId: 0,
    };
  },
  components: {
    ShopPreview,
    NoDataBox,
  },
  methods: {
    generalSetting(key) {
      const settings = this.$store.getters.generalSettings;

      if (settings != null) {
        return settings.instanceSettings[key];
      }

      return false;
    },

    async getSigleWoocommerceProduct(external_id, session_id) {
      const single_product = await this.$store.dispatch("get", { url: `https://test.dgm.se/wp-json/dgm-lms/product?sku=${external_id}&session_key=${session_id}`, config: "" });
      return single_product;
    },
  },
};
</script>
